import React from "react";
import * as T from "prop-types";

import { Field, Inputs } from "2g-form";

import { ADMIN } from "b2b/api/paths";
import { DoplnkovaSluzbaFull } from "b2b/renderers/ciselnik/";

import useMessages from "./i18n/useMessages";

export function ACDoplnkoveSluzby({ ...props }) {
  const {
    doplnkovaSluzbaLabel,
    doplnkovaSluzbaLabelMultiple,
    doplnkovaSluzbaPlaceholder,
    doplnkovaSluzbaPlaceholderMultiple
  } = useMessages();
  return (
    <Field
      component={Inputs.AutoComplete}
      url={ADMIN.doplnkoveSluzby()}
      rendererSelected={DoplnkovaSluzbaFull}
      rendererOption={DoplnkovaSluzbaFull}
      loadOnce
      staticKey={["nazevCs", "nazevEn"]}
      minChars={0}
      label={
        props.multiple ? doplnkovaSluzbaLabelMultiple() : doplnkovaSluzbaLabel()
      }
      placeholder={
        props.multiple
          ? doplnkovaSluzbaPlaceholderMultiple()
          : doplnkovaSluzbaPlaceholder()
      }
      descriptionRenderer={DoplnkovaSluzbaFull}
      {...props}
    />
  );
}

ACDoplnkoveSluzby.propTypes = {
  multiple: T.bool
};

export default React.memo(ACDoplnkoveSluzby);
